import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import { GOALS } from 'utils/constants/collectionNames';
import {
  GET_GOAL_SUCCEED,
  GET_GOAL_ERROR,
  CREATE_GOAL_SUCCEED,
  CREATE_GOAL_ERROR,
  EXERCISE_LOADING_STATE
} from './types';


export const getGoal = (clientId, history) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore.collection(GOALS).doc(clientId);
  dispatch({
    type: EXERCISE_LOADING_STATE
  });
  await docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        if(doc.data().created_at) {
          dispatch({
            type: GET_GOAL_SUCCEED,
            payload: {
              ...doc.data(),
              created_at: toDateFormat(doc.data().created_at),
              performance: { ...doc.data().performance, due_date: toDateFormat(doc.data().performance.due_date) },
              id: doc.id
            }
          });
        } else {
          dispatch({
            type: GET_GOAL_SUCCEED,
            payload: {}
          });
        }
      } else {
        dispatch({
          type: GET_GOAL_SUCCEED,
          payload: {}
        });
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_GOAL_ERROR,
        payload: `error: ${error}`
      });
      history.replace('/event-not-found');
    });
};

export const addGoal = (goal, clientId, history) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(GOALS).doc(clientId);
  return docRef
    .set(goal)
    .then(() => {
      dispatch({
        type: CREATE_GOAL_SUCCEED
      });
      history.push(`/clients/${clientId}`);
      return 
    })
    .catch((error) => {
      console.log(error);
      dispatch({
        type: CREATE_GOAL_ERROR,
        payload: `error: ${error}`
      });
    });
};

